import {
	StyledMenuDropdown,
	StyledMenuItem,
} from '@dealstack/frontend/shared/components/Documents/DocumentsTable/styled';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	onRowClick: () => void;
	downloadFile: () => void;
	removeDocument?: () => void;
	previewFile: () => void;
}

export const DocumentTableActions = ({
	onRowClick,
	downloadFile,
	removeDocument,
	previewFile,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<StyledMenuDropdown>
			<StyledMenuItem
				onClick={(e) => {
					e.stopPropagation();
					onRowClick();
				}}
				leftSection={<Icon variant="information" size="lg" color="black" />}
			>
				{tCapManage('documents.list.actions.document-details')}
			</StyledMenuItem>
			<StyledMenuItem
				onClick={(e) => {
					e.stopPropagation();
					previewFile();
				}}
				leftSection={<Icon variant="document-v3" size="lg" color="black" />}
			>
				{tCapManage('documents.list.actions.preview')}
			</StyledMenuItem>
			<StyledMenuItem
				onClick={(e) => {
					e.stopPropagation();
					downloadFile();
				}}
				leftSection={<Icon variant="download-v3" size="lg" color="black" />}
			>
				{tCapManage('documents.list.actions.download')}
			</StyledMenuItem>
			{removeDocument && (
				<StyledMenuItem
					onClick={(e) => {
						e.stopPropagation();
						removeDocument();
					}}
					leftSection={<Icon variant="delete" size="lg" color="black" />}
				>
					{tCapManage('documents.list.actions.delete')}
				</StyledMenuItem>
			)}
		</StyledMenuDropdown>
	);
};
